<template lang="pug">
.story-publication(:class="(multiplePublications) ? 'panel panel-default' : ''")
  template(v-if="multiplePublications")
    .panel-heading
      h4
        | {{ name }}
        |
        |
        i.fa.fa-angle-down
  div(:class="(multiplePublications) ? 'panel-body' : ''")
    LabelledValue(label="Exported at" :value="exportedAt")
    LabelledValue(label="Content type" :value="storyPublication.content_type_key")
    LabelledValue(label="Story template" :value="storyTemplate")
    LabelledValue(label="Subsites" :value="subsiteNames")
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapStores, mapState } from 'pinia'
  import { invert, pick } from 'lodash'
  import { useCommunityqStoryTemplatesStore } from '@/stores/communityq_story_templates'
  import { usePublicationsStore } from '@/stores/publications'
  import { useSubsitesStore } from '@/stores/subsites'

  import LabelledValue from '@/components/shared/labelled_value.vue'

  export default {
    components: {
      LabelledValue
    },

    props: {
      storyPublication: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapStores(useCommunityqStoryTemplatesStore, usePublicationsStore, useSubsitesStore),
      ...mapState(usePublicationsStore, { multiplePublications: 'hasMultiple' }),
      ...mapState(useSubsitesStore, { subsitesByPub: 'forPublicationAsObject' }),

      name() {
        return this.publicationsStore.getForId(this.storyPublication.publication_id)?.name
      },

      exportedAt() {
        const { exported_at } = this.storyPublication

        if(!exported_at) return null

        const time = new Date(Date.parse(exported_at))
        return time.toLocaleString()
      },

      storyTemplate() {
        const { story_template_id } = this.storyPublication

        return this.communityqStoryTemplatesStore.byId(story_template_id)?.title
      },

      subsiteNames() {
        const { publication_id, subsite_ids } = this.storyPublication
        const subsites = this.subsitesByPub(publication_id)

        return Object.values(pick(invert(subsites), subsite_ids))
      }
    },

    async created() {
      const { publication_id } = this.storyPublication

      await this.publicationsStore.fetchOnce()
      await this.communityqStoryTemplatesStore.fetchOnce(publication_id)
    }
  }
</script>
